import { EnvironmentProviders, Injectable, Provider } from "@angular/core"

@Injectable({
    providedIn: 'root',
})
export class MessagesConfigService {
    constructor() {}
}

export const provideMessages = (): Array<Provider | EnvironmentProviders> => {
    return []
  }